import React, { useContext, useEffect, useMemo, useState } from 'react'
import Header from './Header'
import i18n from '../../../i18n'
import SearchBlock from '../SearchBlock'
import { useTranslation } from 'react-i18next'
import { DContext } from '../../../context/DataContext'
import HeroBg from '../../../assets/landing-bg.jpg'
import HeroBond from '../../../assets/James Bond/img2.jpg'
import HeroIslands from '../../../assets/4islands.jpg'
import HeroHong from '../../../assets/hongisland.jpg'

function Landing() {

  const { t } = useTranslation()
  const { ln, setLn } = useContext(DContext)
  const [activeSlide, setActiveSlide] = useState(0)

  const heroSlides = useMemo(() => {
    const translatedSlides = t('homepage.hero.slides', { returnObjects: true })

    return [
      { image: HeroBond, ...translatedSlides?.[0] },
      { image: HeroIslands, ...translatedSlides?.[1] },
      { image: HeroHong, ...translatedSlides?.[2] },
      { image: HeroBg, ...translatedSlides?.[3] }
    ].filter((slide) => slide.title)
  }, [t])

  useEffect(() => {
    if (heroSlides.length <= 1) {
      return undefined
    }

    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length)
    }, 6500)

    return () => window.clearInterval(timer)
  }, [heroSlides.length])

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLn(lng)
  };

  return (
    <>
      <section className='relative h-[100svh] w-full overflow-hidden bg-slate-950' aria-label='Hero section'>
        <Header ln={ln} changeLanguage={changeLanguage} />

        <div className='absolute inset-0'>
          {heroSlides.map((slide, index) => (
            <article
              key={slide.title}
              className={`absolute inset-0 transition-opacity duration-1000 ${index === activeSlide ? 'opacity-100' : 'opacity-0'}`}
              aria-hidden={index !== activeSlide}
            >
              <img src={slide.image} alt={slide.alt} className='h-full w-full object-cover' />
              <div className='absolute inset-0 bg-[linear-gradient(180deg,rgba(4,10,27,0.20)_0%,rgba(4,10,27,0.38)_42%,rgba(4,10,27,0.78)_100%)]' />
              <div className='absolute inset-0 flex items-center'>
                <div className='mx-auto w-full max-w-6xl px-4 pt-20 sm:px-6 lg:px-8'>
                  <div className='max-w-3xl text-white'>
                    <p className='text-[11px] font-bold uppercase tracking-[0.28em] text-white/75'>{slide.eyebrow}</p>
                    <h1 className='mt-4 text-balance text-4xl font-black tracking-tight drop-shadow-[0_10px_30px_rgba(0,0,0,0.45)] sm:text-6xl lg:text-7xl'>
                      {slide.title}
                    </h1>
                    <p className='mt-5 max-w-2xl text-pretty text-sm leading-relaxed text-white/84 sm:text-lg'>
                      {slide.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}

          <div className='pointer-events-none absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-slate-950 via-slate-950/45 to-transparent' />
          <div className='pointer-events-none absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-slate-950/75 via-slate-950/35 to-transparent' />

          <div className='absolute bottom-6 left-1/2 z-20 -translate-x-1/2 rounded-full border border-white/40 bg-white/90 px-3 py-2 shadow-[0_18px_40px_rgba(15,23,42,0.24)] backdrop-blur-md'>
            <div className='flex items-center gap-3'>
              {heroSlides.map((slide, index) => (
                <button
                  key={slide.title}
                  type='button'
                  aria-label={slide.dotLabel}
                  className={`h-4 w-4 rounded-full transition-all duration-300 ${index === activeSlide ? 'bg-[#1739bd] shadow-[0_0_0_4px_rgba(23,57,189,0.24)]' : 'bg-slate-300 hover:bg-slate-400'}`}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>

      </section>

      <section className='bg-white px-3 py-6 sm:px-5 sm:py-8'>
        <div className='mx-auto max-w-6xl'>
          <SearchBlock showButton={true} />
        </div>
      </section>
    </>
  )
}

export default Landing